import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from '@/app/App';
/* i18n, the self-hosted fonts and the stylesheets, in their load-bearing order. Shared with the
 * Suite remote's entry so the two cannot drift; see the file for why each is where it is. */
import '@/app/globals';

const container = document.getElementById('root');
if (container === null) {
  /* index.html owns the mount point. Failing loudly beats rendering into a detached node and
   * spending an afternoon wondering why the page is blank. */
  throw new Error('#root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    {/* The router lives here rather than inside `App`, so a test can render `App` inside a
        MemoryRouter and drive navigation without a real history. */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
